import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../../common/template/content';
import Tabs from '../../common/tab/tabs';
import TabsHeader from '../../common/tab/tabsHeader';
import TabsContent from '../../common/tab/tabsContent';
import TabHeader from '../../common/tab/tabHeader';
import TabContent from '../../common/tab/tabContent';
import PermissaoUsuario from '../../auth/permissao';
import { init, create, update, movimentar } from './estoqueActions';

import List from './estoqueList';
import Form from './estoqueForm';
import MovForm from './estoqueMovForm';

class Estoque extends Component {
  componentWillMount() {
    this.props.init();
  }

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadManutencaoEstoque" campo="incluir" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEstoque" campo="alterar" condicao={true}>
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEstoque" campo="movimentar" condicao={true}>
                <TabHeader label="Movimentar" icon="dolly" target="tabMov" />
              </PermissaoUsuario>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.props.create} submitClass="primary" submitLabel="Salvar" premiumLayout />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form onSubmit={this.props.update} submitClass="primary" submitLabel="Salvar" premiumLayout isUpdate />
              </TabContent>
              <TabContent id="tabMov">
                <MovForm onSubmit={this.props.movimentar} />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init, create, update, movimentar }, dispatch);
export default connect(null, mapDispatchToProps)(Estoque);
